// import Loader from "../Components/Loader";
import { Link, NavLink } from 'react-router-dom';
import { useGetSettingQuery } from '../../../Redux/Apis/siteApi';

function Header() {
    const {data : { logo, menu}} = useGetSettingQuery()

    return ( 
        <>
        {/* <Loader/> */}
        <div className="top-header-area" id="sticker">
            <div className="container">
                <div className="row">
                    <div className="col-lg-12 col-sm-12 text-center">
                        <div className="main-menu-wrap">

                            {/* <!-- menu start --> */}
                            <nav className="main-menu navbar navbar-expand-lg navbar-dark">
                                <div className="navbar-brand">
                                    <Link to="/">
                                        <img src={logo} width={120} className='img-fluid' alt=""/>
                                    </Link>
                                </div>
                                <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
                                    <i className="fas fa-bars"></i>
                                </button>

                                <div className="collapse navbar-collapse" id="navbarSupportedContent">
                                    <ul className="navbar-nav mx-auto">
                                        {/* <li className="current-list-item"><a href="#!">خانه</a></li> */}
                                        {menu && menu.map((row,index) => 
                                            <li key={index} className="nav-item mx-auto"><NavLink to={row.value} end caseSensitive>{row.key}</NavLink></li>
                                        )}
                                    </ul>
                                    <div className="header-icons">
                                        <Link className="shopping-cart" to="/shop"><i className="fas fa-shopping-cart"></i></Link>
                                    </div>
                                </div>
                            </nav>
                            {/* <!-- menu end --> */}
                        </div>
                    </div>
                </div>
            </div>
        </div>
        </>
     );
}

export default Header;